// backward compatibility
import { tools } from '@iobroker/js-controller-common';

export default tools;
